import { Link } from 'react-router-dom';
import './Navbar.scss';

const Navbar = () => {
    return (
        <header className="navbar flex-column small-gap">
            <div className="flex-row medium-gap">
                <p className="text-caption">COMPUTER SCIENCE</p>
                <p className="text-caption">COGNITIVE SCIENCE</p>
                <p className="text-caption">APPLIED MATH</p>
            </div>
            <h1 className="text-center">New Park Times</h1>
            <nav className="flex-row large-gap">
                <Link to="/"><span>Home</span> &or;</Link>
                <Link to="/projects"><span>Projects</span> &or;</Link>
                <Link to="/contact"><span>Contact</span> &or;</Link>
            </nav>
            <div className="double-line"></div>
        </header>
    )
}

export default Navbar;